
export const openContentBlocksNav = (
  setContentBlocksOpen: React.Dispatch<React.SetStateAction<boolean>>,
  setRulesOpen: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setRulesOpen(false);
  setContentBlocksOpen(true);
};

export const closeContentBlocksNav = (setContentBlocksOpen: React.Dispatch<React.SetStateAction<boolean>>) => {
  setContentBlocksOpen(false);
};
